import * as React from 'react';

import { 
  Box, 
  Typography, 
  Select,
  MenuItem,
  Tooltip,
  IconButton,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { TS_CONSTS } from '../../../utils';
import { Confirmation } from '../../utils';

export default function Selector(props) {

    const {select} = props;

    const [catalog, setCatalog]     = React.useState([]);
    const [option, setOption]       = React.useState(0);
    const [confirmUi, showConfirm]  = React.useState(false);
    const [confirmUiMsg, setConfirmMsg]  = React.useState('');

    React.useEffect(() => {
        handleLoad();
    }, []);

    React.useEffect(() => {
        if(!confirmUiMsg){
            return;
        }

        showConfirm(true);
    }, [confirmUiMsg])

    const handleLoad = async() => {
        createCatalog();        
    }

    const createCatalog = async() => {
        var result = [];

        for( const k in TS_CONSTS.AREAS) {
            result.push({...TS_CONSTS.AREAS[k], key: k});
        }

        setCatalog(result);
    }

    const handleSelection = async() => {
        if(option == 0){
            alert('Pick one Area for this device');
            return;
        }

        setConfirmMsg(`-- Confirm the station setup -- \n
            Selected Area: ${TS_CONSTS.AREAS[option].name}
            `);
    }

    const handleClose = async() => {
        showConfirm(false);
        setConfirmMsg('');
    }

    const handleConfirm = async() => {
        select(option);
    }

    return(
        <Box
            sx={{
                padding: 4,
                border:1,
                borderRadius: 4
            }}
        >
            <Confirmation 
                open={confirmUi} 
                onClose={handleClose} 
                onConfirm={handleConfirm}
                title={'Area Selection'}
                msg={confirmUiMsg}
            />

            <Typography component="h1" variant="h5">
              Area Picker
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
            >
                <Select
                    sx={{
                        width:'100%'
                    }}
                    id="kind"
                    name='kind'
                    value={option}
                    onChange={(e) => setOption(e.target.value)}
                    size='small'
                >
                    <MenuItem key={0} value={0} selected disabled>Select Area</MenuItem>

                    {catalog.map((value, i) => (
                        <MenuItem key={i} value={value.key}>{value.name}</MenuItem>
                    ))}

                </Select>
                <Tooltip title="Select Area">
                    <IconButton onClick={handleSelection}>
                        <CheckIcon color='primary' />
                    </IconButton>
                </Tooltip>
            </Box>

        </Box>
    );
}